<template>
  <div class="fert-summary">
    <MainHeader>
      {{$ml.get('Fertilizer summary')}}
    </MainHeader>
    <table class="th-table">
      <tr class="head">
        <td>
          {{$ml.get('Fertilizer name')}}
        </td>
        <td>
          {{$ml.get('Amount')}}
        </td>
        <td>
          {{$ml.get('Cost')}}
        </td>
      </tr>
      <tr v-for="fert in section">
        <td>
          {{ $ml.get(fert.Name) }}
        </td>
        <td>
          {{ parseFloat($store.getters['unit/convert'](fert.Unit ,fert.Concentration)).toFixed(2) }} {{ $ml.get($store.getters['unit/getLabel']($renderUnit(fert.Unit))) }}
        </td>
        <td>
          {{ fert.Cost ? fert.Cost.toFixed(2) + $renderCurrency() : '-' }}
        </td>
      </tr>
    </table>

    <div class="total-cost">
      {{$ml.get('Total cost:')}}
      <b>{{ $ml.get(totalCost) }}</b>
    </div>

    <NutChart/>
  </div>
</template>

<script>
import HeadLine from './../components/common/HeadLine';
import MainHeader from './../components/common/MainHeader';
import NutChart from './../components/fert-summary/NutChart';
export default {
  props: {
    data: {},
  },
  computed: {
    
    section() {
      return this.$root.data.fertSummary
    },

    totalCost() {
      return this.section.reduce((cost, n) => {
        return cost + (n.Cost ? n.Cost : 0);
      }, 0).toFixed(2) + this.$renderCurrency();
    },
  },
  components: {
    MainHeader,
    NutChart,
  },
}
</script>

<style lang="scss" scoped>

.fert-summary {
  .total-cost {
    padding: 0 10px;
    text-align: right;
    font-size: 13px;
  }
}

</style>